<template>
  <div class="ac-card-content">
    <div class="ac-body-container">
      <div class="ac-close-container">
        <button type="button" class="ac-close-btn" @click="close">
          <img src="@shared/assets/img/general/x-black.png" alt="Close" />
        </button>
      </div>
      <div class="ac-section-container">
        <div class="ac-body-header">Smart Maintenance&reg; Disclaimer</div>
        <div class="ac-body-text">
          <span
            v-if="
              plan?.creditAccrualMethod?.toLowerCase() === 'hub' ||
              plan?.creditAccrualMethod?.toLowerCase() === 'location'
            "
          >
            Pricing for first unit is {{ charge("first") }}, second unit is
            {{ charge("second") }} and additional systems are {{ charge("addon") }}.
          </span>
          <span v-else> Pricing is {{ charge("first") }}. </span>
          <span v-if="plan?.comfortCreditInitial && plan?.comfortCreditEnabled">
            <span
              v-if="
                plan?.creditAccrualMethod?.toLowerCase() === 'hub' ||
                plan?.creditAccrualMethod?.toLowerCase() === 'location'
              "
            >
              {{ loyaltyName }} accrue at {{ comfortCredit("first") }}, second unit is
              {{ comfortCredit("second") }} and additional systems are
              {{ comfortCredit("addon") }}. {{ loyaltyName }} carry no cash value, but can
              be applied towards future invoices or items as specified by your Service
              Provider.
            </span>
            <span v-else>
              {{ loyaltyName }} accrue at {{ comfortCredit("first") }}.
              {{ loyaltyName }} carry no cash value, but can be applied towards future
              invoices or items as specified by your Service Provider.
            </span>
          </span>
        </div>
        <div
          v-if="plan?.comfortCreditInitial && plan?.comfortCreditEnabled"
          class="ac-body-text"
        >
          <span v-if="plan?.minRepairCost">
            {{ loyaltyName }} may be applied to any major HVAC expense over
            {{ minRepairCost(plan.minRepairCost) }} dollars.
          </span>
          <span v-if="plan?.redemptionRestriction">
            *{{ loyaltyName }}: {{ plan.redemptionRestriction }}
          </span>
        </div>
      </div>
      <div class="ac-section-container">
        <div class="ac-body-header">Partner's Exclusions & Disclaimer</div>
        <div class="ac-body-text">
          {{ partnerSettings.PLAN_DISCLAIMER || "--" }}
        </div>
      </div>
      <div
        v-if="
          plan?.inspectionFlex > 0 ||
          plan?.inspectionPerson > 0 ||
          plan?.inspectionVirtual > 0
        "
        class="ac-section-container"
      >
        <div class="ac-body-header">System Inspections</div>
        <fragment v-if="plan?.inspectionVirtual > 0">
          <div class="ac-body-sub-header">Virtual:</div>
          <div class="ac-body-text gray">
            Partner will use the SmartAC.com dashboard to remotely review system
            performance and communicate those findings to the homeowner via text, email or
            video.
          </div>
        </fragment>
        <fragment v-if="plan?.inspectionPerson > 0">
          <div class="ac-body-sub-header">In person:</div>
          <div class="ac-body-text gray">
            Partner will visit the home and perform a traditional seasonal maintenance
            call.
          </div>
        </fragment>
        <fragment v-if="plan?.inspectionFlex > 0">
          <div class="ac-body-sub-header">Flex/Floating:</div>
          <div class="ac-body-text gray">
            Partner will proactively monitor system performance through the SmartAC.com
            dashboard and will visit the home only when an issue (or potential issue) is
            detected.
          </div>
        </fragment>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlanDetail",
  props: {
    close: Function,
    plan: Object,
    partnerSettings: Object,
  },
  computed: {
    loyaltyName() {
      return this.partnerSettings?.LOYALTY_PROGRAM_NAME || "Comfort Credits";
    },
  },
  methods: {
    charge(unit) {
      if (this.plan) {
        const { priceInitial, priceSecond, priceAddon, chargeFrequency } = this.plan;
        let frequency = chargeFrequency;
        if (frequency === "Monthly") {
          frequency = "month";
        } else if (frequency === "Yearly") {
          frequency = "year";
        } else if (frequency === "One time") {
          frequency = "once";
        }
        let price;
        if (unit === "first" && priceInitial) {
          price = priceInitial;
        }
        if (unit === "second" && priceSecond) {
          price = priceSecond;
        }
        if (unit === "addon" && priceAddon) {
          price = priceAddon;
        }
        if (!price) {
          price = 0;
        }
        if (price % 1 !== 0) {
          price = Number(price).toFixed(2);
        }
        return `$${price}/${frequency}`;
      }
      return "{{$-/month}}";
    },
    comfortCredit(unit) {
      if (this.plan) {
        const {
          comfortCreditInitial,
          comfortCreditSecond,
          comfortCreditAddon,
          creditAccrualFrequency,
        } = this.plan;
        let frequency = creditAccrualFrequency;
        if (frequency === "Monthly") {
          frequency = "month";
        } else if (frequency === "Yearly") {
          frequency = "year";
        }
        if (unit === "first" && comfortCreditInitial) {
          return `$${comfortCreditInitial}/${frequency}`;
        }
        if (unit === "second" && comfortCreditSecond) {
          return `$${comfortCreditSecond}/${frequency}`;
        }
        if (unit === "addon" && comfortCreditAddon) {
          return `$${comfortCreditAddon}/${frequency}`;
        }
      }
      return "{{$-/month}}";
    },
    minRepairCost(cost) {
      if (cost) {
        return `$${cost}`;
      }
      return "{{minInvoicePrice}}";
    },
  },
};
</script>

<style lang="scss" scoped>
.ac-section-container {
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 16px;
  }
}

.ac-body-header {
  font-size: 1.125em;
  font-weight: 700;
  text-align: left;
  width: 100%;
  margin-bottom: 8px;
}

.ac-body-sub-header {
  font-size: 1em;
  font-weight: 500;
  color: $N70;
  margin-bottom: 4px;

  &:not(:first-child) {
    margin-top: 12px;
  }
}

.ac-body-text {
  font-size: 1em;
  color: $NAVY100;

  &.gray {
    color: $N70;
  }
}
</style>
